import React from "react";

export const PRIVACY = {
  title: "Privacy Policy",
  body: (
    <>
      <p>
        <strong>Effective Date: February 17, 2025</strong>
      </p>
      <p>
        Welcome to Episcope AI ("we", "us", "our"). We value your privacy and are committed
        to protecting your personal information. This Privacy Policy explains how we
        collect, use, and safeguard the information you provide when you visit our
        website.
      </p>
      <h3>1. Information We Collect</h3>
      <p>
        - We may collect personal information such as your name, email address, phone
        number, and any other details you voluntarily provide when contacting us or
        signing up for our services.
        <br />- We also gather non-personal information such as your IP address, browser
        type, and usage data through cookies and similar technologies.
      </p>
      <h3>2. How We Use Your Information</h3>
      <p>
        - To provide, maintain, and improve our services.
        <br />- To respond to your inquiries and offer customer support.
        <br />- To send you newsletters, updates, and marketing communications (if you have
        opted in).
        <br />- To analyze website usage and enhance user experience.
      </p>
      <h3>3. Sharing Your Information</h3>
      <p>
        - We do not sell, rent, or share your personal information with third parties for
        marketing purposes.
        <br />- Your information may be shared with trusted service providers who assist in
        operating our website and delivering our services.
        <br />- We may disclose your information when required by law or in response to a
        valid legal request.
      </p>
      <h3>4. Data Security</h3>
      <p>
        - We implement appropriate technical and organizational measures to protect your
        personal data.
        <br />- Despite our efforts, no security system is completely impenetrable, and we
        cannot guarantee absolute security.
      </p>
      <h3>5. Your Rights</h3>
      <p>
        - You have the right to access, correct, or delete your personal information.
        <br />- To exercise these rights, please contact us at episcope.ai@gmail.com.
      </p>
      <h3>6. Cookies</h3>
      <p>
        - Our website uses cookies to enhance your experience. You may adjust your browser
        settings to refuse cookies; however, this may affect certain functionalities of
        our website.
      </p>
      <h3>7. Changes to This Privacy Policy</h3>
      <p>
        - We may update this Privacy Policy from time to time. Any changes will be posted
        on this page with an updated effective date.
        <br />- Please review this policy periodically to stay informed about how we are
        protecting your information.
      </p>
      <h3>8. Contact Us</h3>
      <p>
        - If you have any questions or concerns about this Privacy Policy, please contact
        us at episcope.ai@gmail.com.
      </p>
      <p>
        By using our website, you acknowledge that you have read and understood this
        Privacy Policy and agree to its terms.
      </p>
    </>
  ),
};

export const TERMS = {
  title: "Terms of Service",
  body: (
    <>
      <p>
        <strong>Effective Date: February 17, 2025</strong>
      </p>
      <p>
        Welcome to Episcope AI. These Terms of Service ("Terms") govern your use of our
        website and services. By accessing or using our website, you agree to be bound by
        these Terms. If you do not agree with any part of these Terms, please refrain from
        using our services.
      </p>
      <h3>1. Acceptance of Terms</h3>
      <p>
        - By using our website, you agree to comply with these Terms and all applicable
        laws.
        <br />- If you do not agree with these Terms, please do not use our services.
      </p>
      <h3>2. Use of the Website</h3>
      <p>
        - You agree to use our website only for lawful purposes.
        <br />- You agree not to engage in any activity that may damage, disable, or impair
        the website or its servers.
      </p>
      <h3>3. Account Registration</h3>
      <p>
        - Where applicable, you agree to provide accurate and complete information when
        registering an account.
        <br />- You are responsible for maintaining the confidentiality of your account
        credentials and for all activities that occur under your account.
      </p>
      <h3>4. Intellectual Property</h3>
      <p>
        - All content on this website, including text, graphics, logos, images, and
        trademarks, is the property of Episcope AI or its licensors and is protected by
        copyright and intellectual property laws.
        <br />- You may not reproduce, modify, or distribute any content without our prior
        written consent.
      </p>
      <h3>5. Prohibited Conduct</h3>
      <p>
        - You agree not to engage in any activities that interfere with or disrupt the
        proper functioning of the website.
        <br />- You agree not to attempt unauthorized access to any portion of the website.
      </p>
      <h3>6. Disclaimer of Warranties</h3>
      <p>
        - The website and its services are provided on an "as is" and "as available" basis
        without any warranties, express or implied.
        <br />- Episcope AI does not guarantee that the website will be error-free or
        uninterrupted.
      </p>
      <h3>7. Limitation of Liability</h3>
      <p>
        - In no event shall Episcope AI be liable for any indirect, incidental, special, or
        consequential damages arising from your use or inability to use our website or
        services.
      </p>
      <h3>8. Termination</h3>
      <p>
        - We reserve the right to suspend or terminate your access to the website at any
        time, without notice, if you breach these Terms.
      </p>
      <h3>9. Changes to These Terms</h3>
      <p>
        - We may modify these Terms at any time. Changes will be effective upon posting on
        the website.
        <br />- Your continued use of the website after such changes constitutes your
        acceptance of the new Terms.
      </p>
      <h3>10. Governing Law</h3>
      <p>
        - These Terms are governed by and construed in accordance with the laws of the
        Netherlands.
        <br />- Any disputes arising from these Terms shall be resolved in the appropriate
        courts of Den Haag, Netherlands.
      </p>
      <h3>11. Contact Us</h3>
      <p>
        - If you have any questions or concerns about these Terms of Service, please
        contact us at episcope.ai@gmail.com.
      </p>
      <p>
        By using our website, you acknowledge that you have read, understood, and agree to
        these Terms of Service.
      </p>
    </>
  ),
};
